
import {
    RELATED_TERMS_CHANGE,
    MULTI_RELTED_TERMS_CHANGE
 } from '../../actions/types';
 
 const initialState = {
     distantlyRelated: [],
     closelyRelated: [],
     multiTerms: []
 };
 
 
 const setRelatedTerms = (state, action) => {
     let distantlyRelated = action.payload.distantlyRelatedKeywords || [];
     let closelyRelated = action.payload.closelyRelatedKeywords || [];
     return {
         ...state,
         distantlyRelated,
         closelyRelated,
         multiTerms: []   
     }
 }

 const setMultiTerms = (state, action) => {
     let multiTerms = action.payload.results || [];

     return {
         ...state,
         multiTerms
     }
 }
 
 
 export default (state = initialState, action) => {
     switch (action.type) {
         case RELATED_TERMS_CHANGE:
             return setRelatedTerms(state,action);
             break;

        case MULTI_RELTED_TERMS_CHANGE:
            return setMultiTerms(state, action)
 
         default:
             return state;
             break;
     }
 }